export default __webpack_public_path__ + "static/media/circleTick.0288fd07.svg";